import {CONTRACTOR_ADMINS_REQUEST, CONTRACTOR_ADMINS_SUCCESS, CONTRACTOR_ADMINS_FAILURE} from '../actions';
import {STORE_CONTRACTOR_ADMIN_REQUEST, STORE_CONTRACTOR_ADMIN_SUCCESS, STORE_CONTRACTOR_ADMIN_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_ADMIN_REQUEST, UPDATE_CONTRACTOR_ADMIN_SUCCESS, UPDATE_CONTRACTOR_ADMIN_FAILURE} from '../actions';
import adminReducer from './contractor-admin';

export const CONTRACTOR_ADMINS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const updateAdmin = (state, action) => {
    let {data} = state;
    const {id} = action;
    const admin = data.find(b => b.id === id);
    data.splice(data.indexOf(admin), 1);
    const reduced = adminReducer(admin, action);
    data = [...state.data, reduced];

    return {...state, data};
};

const adminsReducers = {
    [CONTRACTOR_ADMINS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_ADMINS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_ADMINS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_CONTRACTOR_ADMIN_REQUEST]: (state, action) => {
        const admin = adminReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), admin];

        return {...state, data};
    },
    [STORE_CONTRACTOR_ADMIN_SUCCESS]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = adminReducer(admin, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_CONTRACTOR_ADMIN_FAILURE]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = adminReducer(admin, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_CONTRACTOR_ADMIN_REQUEST]: updateAdmin,
    [UPDATE_CONTRACTOR_ADMIN_SUCCESS]: updateAdmin,
    [UPDATE_CONTRACTOR_ADMIN_FAILURE]: updateAdmin
};

export default function admins(state = CONTRACTOR_ADMINS_INITIAL_STATE, action) {
    let reducer = adminsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-admins.js